import {
  SET_AGENT_WHATSAPP_CAMPAIGNS,
  RESET_AGENT_WHATSAPP_CAMPAIGNS,
} from '../../mutation-types';

const mutations = {
  [SET_AGENT_WHATSAPP_CAMPAIGNS](state, agentWhatsappCampaigns) {
    state.agentWhatsappCampaigns = agentWhatsappCampaigns;
  },

  [RESET_AGENT_WHATSAPP_CAMPAIGNS](state) {
    state.agentWhatsappCampaigns = [];
  },
};

export default mutations;
